import { combineReducers } from "redux";

import authReducer from "./Auth";
import usersReducer from "./user";
import investmentReducer from "./investment";
import regulatorReducer from "./regulator";
import investmentTypeReducer from "./investmentType";
import newInvestmentReducer from "./newInvestments";
import approvedInvestmentReducer from "./approvedInvestment";
import yearStatsReducer from "./yearStats";
import monthStatsReducer from "./monthStats";
import undefinedRateReducer from "./undefinedRate";
import approvedUndefinedInvestmentsReducer from "./approvedUndefinedInvestments";
import institutionStats from "./institutionStats";
import impairment from "./impairment";
import institution from "./institution";
import redemption from "./redemption";
import approvedIndividualInvestment from "./approvedIndividualInvestment";
import individualInvestment from "./individualInvestment";
import newIndividualInvestments from "./newIndividualInvestments";
export default combineReducers({
  auth: authReducer,
  users: usersReducer,
  investments: investmentReducer,
  regulators: regulatorReducer,
  investmentTypes: investmentTypeReducer,
  newInvestment: newInvestmentReducer,
  approvedInvestment: approvedInvestmentReducer,
  year_stats: yearStatsReducer,
  month_stats: monthStatsReducer,
  undefinedRate: undefinedRateReducer,
  approvedUndefinedInvestments: approvedUndefinedInvestmentsReducer,
  impaired: impairment,
  institutionStats,
  institution,
  redemption,
  approvedIndividualInvestment,
  individualInvestment,
  newIndividualInvestments,
});
